import React from 'react';
export var LINK_SHADOW_FILTER_KEY = 'linkShadowFilterKey';
export var NODE_SHADOW_FILTER_KEY = 'nodeShadowFilterKey';
var ShadowFilters = function () {
    var filterContent = React.createElement(React.Fragment, null,
        React.createElement("feGaussianBlur", { in: "SourceAlpha", stdDeviation: "1" }),
        React.createElement("feOffset", { dx: "2", dy: "2", result: "offsetblur" }),
        React.createElement("feComponentTransfer", null,
            React.createElement("feFuncA", { type: "linear", slope: "0.5" })),
        React.createElement("feMerge", null,
            React.createElement("feMergeNode", null),
            React.createElement("feMergeNode", { in: "SourceGraphic" })));
    return (React.createElement("defs", null,
        React.createElement("filter", { id: NODE_SHADOW_FILTER_KEY, key: NODE_SHADOW_FILTER_KEY, x: "-100%", y: "-100%", height: "300%", width: "300%" }, filterContent),
        React.createElement("filter", { id: LINK_SHADOW_FILTER_KEY, key: LINK_SHADOW_FILTER_KEY, filterUnits: "userSpaceOnUse", x: "-100%", y: "-100%", height: "300%", width: "300%" }, filterContent)));
};
export default ShadowFilters;
//# sourceMappingURL=ShadowFilters.js.map